module.exports = __webpack_public_path__ + "img/login-comite15denoviembre.7cdd46e6.svg";